import ComingSoon from "../components/ComingSoon";
import { Watch } from "lucide-react";

export default function WearablesComingSoon() {
  return (
    <ComingSoon
      title="Wearables & Health Tracking"
      description="Monitor health metrics from connected devices and wearables. This feature will integrate with popular fitness trackers and health devices to provide continuous health monitoring."
      icon={Watch}
      iconColor="text-blue-600"
      estimatedTime="Q3 2025"
    />
  );
}
